<template>
    <div :class="{ 'cursor-pointer': item.url }" @click="handleClick" v-html="item.description" />
</template>
<script setup>
import { router } from '@inertiajs/vue3';

const props = defineProps({ item: Object });

function handleClick() {
    if (!props.item.url) return;

    router.visit(props.item.url);
}
</script>
